import React from "react"
import _ from "lodash"
import { Link } from "gatsby"

import { rhythm } from "../utils/typography"

class Menu extends React.Component {
  renderMenuItem(item) {
    const { title, url } = item
    return (
      <li
        style={{
          listStyle: "none",
          display: "inline",
          margin: `0px ${rhythm(0.5)}`,
        }}
      >
        <Link
          style={{
            boxShadow: `none`,
            textDecoration: `none`,
          }}
          to={url}
        >
          {title}
        </Link>
      </li>
    )
  }

  render() {
    const menuItems = [
      { title: "Home", url: "/" },
      { title: "Photos", url: "/photos" },
      { title: "Daily", url: "https://daily.haikuco.de" },
      { title: "Writing", url: "/blog" },
      { title: "Book notes", url: "/books" },
      { title: "Contact", url: "/contact" },
    ]

    return (
      <ul
        style={{
          flexDirection: "row",
          marginLeft: rhythm(-0.5),
        }}
      >
        {_.map(menuItems, this.renderMenuItem)}
      </ul>
    )
  }
}

export default Menu
